import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

import { sentenceCase } from 'change-case';

import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import IconButton from '@mui/material/IconButton';

import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';

const CartHeader = ({ cardsPerPage, cartCount, currentCategory, giftCards, setCardsPerPage }) => {
	const navigate = useNavigate();

	const handleRouteToCart = () => {
		navigate('/cart');
		window.scrollTo({ top: 0 });
	};

	return (
		<Stack
			direction='row'
			justifyContent='space-between'
			alignItems='center'
			px={{ xs: 2, sm: 1, md: 1 }}
		>
			<Stack spacing={3} direction='row' alignItems='center'>
				<Typography
					variant='h5'
					sx={{ ml: { xs: 0, md: '30px !important' }, fontSize: { xs: '1.2rem', md: '1.5rem' } }}
				>{`Category: ${sentenceCase(currentCategory)}`}</Typography>
				<Select
					size='small'
					value={cardsPerPage}
					inputProps={{
						id: 'gc-display',
						'aria-label': 'Select how many Gift cards to show on the page'
					}}
					onChange={(e) => setCardsPerPage(e.target.value)}
					aria-label='Select how many Gift cards to show on the page'
					sx={{ display: { xs: 'none', lg: 'block' } }}
				>
					<MenuItem value={8}>8</MenuItem>
					<MenuItem value={16}>16</MenuItem>
					<MenuItem value={24}>24</MenuItem>
					<MenuItem value={48}>48</MenuItem>
				</Select>
				<Typography display={{ xs: 'none', lg: 'block' }}>
					<FormLabel htmlFor='gc-display'>{`Showing ${
						cardsPerPage > giftCards.length ? giftCards.length : cardsPerPage
					} of ${giftCards.length} results`}</FormLabel>
				</Typography>
			</Stack>
			<Tooltip title={<Typography variant='body2'>Go To Cart</Typography>}>
				<IconButton
					sx={{ mr: { xs: 0, md: '30px' }, padding: { xs: '0px', md: '8px' } }}
					onClick={handleRouteToCart}
					aria-label='Go to Cart'
				>
					<Badge badgeContent={cartCount} color='primary'>
						<ShoppingCartOutlinedIcon
							sx={{ fontSize: { xs: '32px', md: '40px' }, color: 'common.black' }}
						/>
					</Badge>
					<Typography sx={{ display: 'none' }}>Cart</Typography>
				</IconButton>
			</Tooltip>
		</Stack>
	);
};

CartHeader.propTypes = {
	cardsPerPage: PropTypes.number,
	cartCount: PropTypes.number,
	currentCategory: PropTypes.string,
	giftCards: PropTypes.array,
	setCardsPerPage: PropTypes.func
};

export default CartHeader;
